import { xray } from 'lib/xray';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

interface QuotaCleanerYearFilterPromoProps {
    target: Element;
    targetListeners: (Element | null)[];
    storeValue: number | null;
    onHide: () => void;
}

export const QuotaCleanerYearFilterPromo: FC<QuotaCleanerYearFilterPromoProps> = ({ target, targetListeners, storeValue, onHide }) => {
    const [isClosed, setIsClosed] = useState(!!storeValue);
    const [isShown, setIsShown] = useState(false);

    const canShow = useMemo(() => target && !isClosed, [target, isClosed]);

    const handleHide = useCallback(() => {
        setIsClosed(true);
        onHide();
    }, [onHide, setIsClosed]);

    const onClose = useCallback(() => {
        handleHide();
        xray.send('quota-cln-year-flt-pr-close');
    }, [handleHide]);

    const onTargetClick = useCallback(() => {
        handleHide();
        xray.send('quota-cln-year-flt-pr-submit');
    }, [handleHide]);

    useEffect(() => {
        const targets = [target, ...targetListeners];
        targets.forEach((target) => target?.addEventListener('click', onTargetClick));
        return () => {
            targets.forEach((target) => target?.removeEventListener('click', onTargetClick));
        };
    }, [target, targetListeners]);

    useEffect(() => {
        if (canShow) {
            setIsShown(true);
        }
    }, [canShow, setIsShown]);

    useEffect(() => {
        if (isShown) {
            xray.send('quota-cln-year-flt-pr-show');
        }
    }, [isShown]);

    if (!canShow) {
        return null;
    }

    return (
        <FloatingTooltip
            target={target}
            title="Фильтр по дате"
            text={'Выберите нужный период, чтобы\nпосмотреть другие письма'}
            placement={ETooltipPlacement.bottomStart}
            closeOnOutsideClick={false}
            qaId="quota-cleaner-year-filter-promo"
            onClose={onClose}
        />
    );
};
